// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Assortment from './assortment';
import { getFilteredAssortment } from '../../store/assortment/selectors';
import { addCriteoListing } from '../../store/gtm';
import { removeAllFilters } from '../../store/assortment';

type StateProps = {|
  pdbIds: Array<string>,
|};

type DispatchProps = {|
  addCriteoListView: () => void,
  removeFilters: () => void,
|};

type RouterProps = {|
  history: any,
  location: any, // eslint-disable-line react/no-unused-prop-types
  match: any, // eslint-disable-line react/no-unused-prop-types
  staticContext: any, // eslint-disable-line react/no-unused-prop-types
|};

type RouterlessProps = {|
  ...StateProps,
  ...DispatchProps,
|};

type Props = {|
  ...RouterlessProps,
  ...RouterProps,
|};

class AssortmentContainer extends Component<Props> {
  unlisten: () => void;

  pathnameOnMount: string;

  componentDidMount() {
    const {
      addCriteoListView, history, removeFilters, location,
    } = this.props;
    addCriteoListView();
    this.pathnameOnMount = location.pathname;
    this.unlisten = history.listen(loc => (
      !loc.search && loc.pathname === this.pathnameOnMount
        && removeFilters()
    ));
  }

  componentWillUnmount() {
    this.unlisten();
  }

  render() {
    const { pdbIds } = this.props;
    return <Assortment pdbIds={pdbIds} />;
  }
}

const mapStateToProps = (state): StateProps => ({
  pdbIds: getFilteredAssortment(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  addCriteoListView: () => dispatch(addCriteoListing()),
  removeFilters: () => dispatch(removeAllFilters()),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter<Props>(AssortmentContainer));
